module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-binary-fill-c4b839b1.svg";